import { ConfiguableSvgProps } from 'src/components/Icons/types';

type Props = Omit<ConfiguableSvgProps, 'color'>;

export default function OrderbookHorizontal({
	width = 16,
	height = 16,
	className,
}: Props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			fill="none"
			className={className}
		>
			<rect
				width="6.316"
				height="2.807"
				x="1.333"
				y="11.86"
				fill="#3FB072"
				rx=".5"
			/>
			<rect
				width="6.316"
				height="2.807"
				x="8.351"
				y="11.86"
				fill="#E7644C"
				rx=".5"
			/>
			<rect
				width="4.211"
				height="2.807"
				x="3.438"
				y="8.351"
				fill="#3FB072"
				rx=".5"
			/>
			<rect
				width="4.211"
				height="2.807"
				x="8.351"
				y="8.351"
				fill="#E7644C"
				rx=".5"
			/>
			<rect
				width="2.807"
				height="2.807"
				x="4.842"
				y="4.842"
				fill="#3FB072"
				rx=".5"
			/>
			<rect
				width="2.807"
				height="2.807"
				x="8.351"
				y="4.842"
				fill="#E7644C"
				rx=".5"
			/>
			<rect
				width="1.404"
				height="2.807"
				x="6.246"
				y="1.333"
				fill="#3FB072"
				rx=".5"
			/>
			<rect
				width="1.404"
				height="2.807"
				x="8.351"
				y="1.333"
				fill="#E7644C"
				rx=".5"
			/>
		</svg>
	);
}
